<template>
    <v-list class="py-0" dense>
        <v-list-item @click="irANotificaciones">
            <v-list-item-icon class="mr-3 my-3">
                <v-avatar size="20" color="red">
                    <span class="white--text">
                        {{ cantidadAvisosNoLeidos }}
                    </span>
                </v-avatar>
            </v-list-item-icon>
            <v-list-item-content class="text-center">
                <v-list-item-title class="font-weight-regular text-subtitle-2">
                    NOTIFICACIONES
                </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class="my-3">
                <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-action>
        </v-list-item>
    </v-list>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'menuNotify',

    computed: {
        ...mapGetters('avisos', ['cantidadAvisosNoLeidos']),
    },

    methods: {
        irANotificaciones() {
            this.$router.push('/notificaciones').catch(() => { })
        },
    },
}
</script>
